var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBottomError)?_c('div',{on:{"click":function($event){return _vm.dismiss()}}},[_c('div',{staticClass:"main-text"},[_c('p',[_vm._v(_vm._s(_vm.errorMessage))]),_c('div',{staticClass:"dismiss-button"},[_vm._v("Ok")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }